import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import connectSiteProvider from '../service/ServiceSiteConnector';
import Link from './TextLink';

// This component works for all dialogs opened by a dialogEntityId
// with the dbn.showDialog() function

class InfoIButton extends PureComponent {

  render() {
    const {
      dialogEntityId,
      ui,
      className,
      dialogTemplates,
      customOnClick,
      customHeadline,
    } = this.props;

    const buildAriaLabel = customHeadline
      ? `${ui?.guiWordLearnMoreAbout || ''} ${customHeadline}`
      : `${ui?.guiWordLearnMoreAbout || ''} ${dialogTemplates?.[dialogEntityId]?.headline || ''}`;

    return (
      <Link
        ariaLabel={buildAriaLabel}
        className={className}
        element="button"
        onClick={(e) => {
          e.preventDefault();
          if (typeof customOnClick === 'function') {
            customOnClick(e);
          } else {
            // eslint-disable-next-line no-undef
            dbn.showDialog(dialogEntityId);
          }
        }}
        withoutArrow
        withoutStyle
        icon="/icons/content-info.svg"
        size="small"
      />
    );
  }
}

InfoIButton.propTypes = {
  dialogEntityId: PropTypes.string,
  className: PropTypes.string,
  customOnClick: PropTypes.func,
  customHeadline: PropTypes.string,
};

const mapStateToProps = (state) => ({
  dialogTemplates: state.site.dialogTemplates,
  ui: state.ui,
});

export default compose(
  connectSiteProvider(),
  connect(mapStateToProps),
)(InfoIButton);
